// extracted by mini-css-extract-plugin
module.exports = {"couponWrapper":"styles-module__couponWrapper___1s6eX","couponRow1":"styles-module__couponRow1___3yv4W","couponRow2":"styles-module__couponRow2___16pob"};